import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { LangContext } from "../../context/LangContext";
import { useCheckCart } from "../../hooks/useCheckCart";
import BtnCart from "../../components/BtnCart";
import Paging from "../../components/Paging";
import Payments from "../../payments";
import "./style.css"

function Shop() {
    const checkCart = useCheckCart();

    const [page, setPage] = useState(0);
    const [articles, setArticles] = useState([]);

    const cartIsOpen = useSelector(state => state.options.cartIsOpen);
    const { language, translations } = useContext(LangContext);

    useEffect(() => {
        const fetchWorks = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/articles/get/all`);
            const res = await req.json();

            if (req.status !== 200) {
                alert(res.message);
                return
            };

            const response = res.sort((a, b) => a.order - b.order);

            const chunkedData = [];
            const chunkSize = 20;

            for (let i = 0; i < response.length; i += chunkSize) {
                const chunk = response.slice(i, i + chunkSize);
                chunkedData.push(chunk);
            }

            const lastPaging = parseInt(sessionStorage.getItem('paging_shop')) || 0;
            const validPage = Math.min(lastPaging, chunkedData.length - 1);

            setPage(validPage >= 0 ? validPage : 0);
            setArticles(chunkedData);
            checkCart();
        }
        fetchWorks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (page !== -1) sessionStorage.setItem('paging_shop', page);
    }, [page]);

    return articles && (
        <div className='page page_shop'>
            <BtnCart anim='' />

            <p className="title_page">-<span>Shop</span>-</p>

            <section className="sect_articles">
                <ul className="articles_list">
                    {articles.length !== 0 && articles[page].map((article, idx) =>
                        <li key={idx}>
                            <Link to={`/${language}/articles/${article.title_path}`}>
                                <div className="preview">
                                    <i className="img" style={{ backgroundImage: `url(${article.images[0]._url})` }}></i>
                                    <p className="hover">-<span>{translations.view}</span>-</p>
                                </div>

                                <h2>- {article[`title_${language}`]} -</h2>
                            </Link>
                        </li>
                    )}
                </ul>

                {articles.length > 1 && <Paging data={articles} page={page} setPage={setPage} />}
            </section>

            {/* {cartIsOpen && <Payments />} */}
        </div>
    )
}

export default Shop;